import './style.css';

const app = document.querySelector<HTMLDivElement>('#app');

if (app) {
  app.innerHTML = `
    <h1>TAPETAUPE</h1>
    <p>Scaffold ready — Phase 0 step 2 ✓</p>
  `;
}
